import _ from 'lodash';
import MapDefaults from '../constants/MapDefaults';

const GeneralHelper = {
	/**
	 * Check if the value is a valid email
	 * @param {string} email 
	 * @returns {boolean}
	 */
	isEmailValid(email) {
		const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	},

	/**
	 * Convert a query from string to javacript object
	 * @param {string} queryString 
	 * @returns {Object}
	 */
	queryStringToObject(queryString) {
		if (!queryString || !_.isString(queryString)) {
			return {};
		}
		if (queryString.indexOf('?') === 0) {
			queryString = queryString.substring(1);
		}
		try {
			return JSON.parse(
				'{"' +
				decodeURI(queryString)
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
				'"}'
			);
		} catch (e) { }
		return {};
	},

	/**
	 * 
	 * @param {Object} obj 
	 * @returns {string}
	 */
	objectToQueryString(obj) {
		const keyValuePairs = [];

		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				const value = obj[key];
				const encodedKey = encodeURIComponent(key);
				const encodedValue = encodeURIComponent(value);
				keyValuePairs.push(`${encodedKey}=${encodedValue}`);
			}
		}

		return keyValuePairs.join('&');
	},

	/**
	 * 
	 * @returns {String}
	 */
	getImageBasePath() {
		const path = process.env.NODE_ENV === 'local' ? '' : '/admin';
		return path;
	},

	/**
	 * 
	 * @returns {Object}
	 */
	getParamsFromUrl() {
		// Create a new URLSearchParams object from the given URL.
		const searchParams = new URLSearchParams(window.location.search);

		// Create an object to store the query string parameters.
		const params = {};

		// Iterate over the query string parameters and add them to the object.
		for (const [key, value] of searchParams) {
			params[key] = value;
		}

		// Return the object of query string parameters.
		return params;
	},

	/**
	 * 
	 * @param {number} ms 
	 * @returns
	 */
	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	},

	/**
	 * This will generate array of numbers similar to python range() function
	 * @param {number} start 
	 * @param {number} stop 
	 * @param {number} step 
	 * @returns {number[]}
	 */
	range(start, stop, step = 1) {
		if (_.isNil(stop)) {
			stop = start;
			start = 0;
		}

		const result = [];

		if (step > 0) {
			for (let i = start; i < stop; i += step) {
				result.push(i);
			}
		} else if (step < 0) {
			for (let i = start; i > stop; i += step) {
				result.push(i);
			}
		}

		return result;
	},

	/**
	 * 
	 * @param {number} length 
	 * @param {boolean} digitOnly 
	 * @returns {string}
	 */
	generateRandomString(length = 20, digitOnly = false) {
		let text = '';
		let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		if (digitOnly) {
			possible = '0123456789';
		}

		for (let i = 0; i < length; i++) {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}

		return text;
	},

	isObjectId(str) { return /^[0-9a-fA-F]{24}$/.test(str); },

	/**
	 * Whether a coordinate falls inside the campus map area (MapDefaults.extent, which is also the
	 * map's maxBounds). Anything outside it has no floor plan and cannot even be panned to.
	 * @param {number} longitude
	 * @param {number} latitude
	 * @returns {boolean}
	 */
	isWithinMapExtent(longitude, latitude) {
		if (!_.isFinite(longitude) || !_.isFinite(latitude)) return false;

		const [[westLng, southLat], [eastLng, northLat]] = MapDefaults.extent;

		return longitude >= Math.min(westLng, eastLng)
			&& longitude <= Math.max(westLng, eastLng)
			&& latitude >= Math.min(southLat, northLat)
			&& latitude <= Math.max(southLat, northLat);
	}
};

export default GeneralHelper;
